import { useState } from 'react';
import { Form, Select, message } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ITransportadoraResponse, transportadoraService } from './services';
import Swal from 'sweetalert2';
import mask from '../../../utils/mask';
import TextFilter from '../../../components/TextFilter';

export const SelectTransportadoraParceira: React.FC = () => {
  const { Option } = Select;
  const [response, setResponse] = useState<ITransportadoraResponse | undefined>();
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const codCdd = useSelector((state: ApplicationState) => state.auth.cddAtivo);

  function handleTransportadoraRequest(): void {
    if (parceiros.length === 0) {
      message.warning(
        'Selecione um parceiro para ter acesso a lista de transportadoras parceiras!'
      );
      return;
    }

    if (localStorage.getItem(`responseTransportadorasFilter${window.location.pathname}`)) {
      const transportadorasFilter = JSON.parse(
        localStorage.getItem(`responseTransportadorasFilter${window.location.pathname}`) || '{}'
      );
      setResponse(transportadorasFilter);
      return;
    }

    try {
      transportadoraService
        .getTransportadorasParceiras(codCdd?.codCdd as number, parceiros)
        .then((res) => {
          setResponse(res.data);
          localStorage.setItem(
            `responseTransportadorasFilter${window.location.pathname}`,
            JSON.stringify(res.data)
          );
        });
    } catch (error: any) {
      if (error.response.data.Error)
        Swal.fire({
          title: error.response.data.Error,
          html: '',
          icon: 'warning',
          showConfirmButton: false,
        });
      else
        Swal.fire({
          title:
            'Não foi possivel carregar as transportadoras parceiras, por favor tente novamente!',
          html: '',
          icon: 'warning',
          showConfirmButton: false,
        });
    }
  }

  return (
    <Form.Item label={<TextFilter>Transportadora</TextFilter>} name="codTransportadora">
      <Select
        filterOption={(inputValue, element) =>
          element?.props.children
            .toString()
            .toLowerCase()
            .replace(/\.|-|\//g, '')
            .includes(inputValue.replace(/\.|-|\//g, '').toLowerCase())
        }
        showSearch
        onFocus={handleTransportadoraRequest}
        placeholder="Selecione a transportadora"
      >
        {response ? (
          response.transportadoras?.map((transportadora) => (
            <Option value={transportadora.codParceiro} key={transportadora.codParceiro}>
              {mask('transportadoraUf', transportadora.nomeParceiro)} <br />
              {mask('cpfCnpj', transportadora.cnpj)} <br />
            </Option>
          ))
        ) : (
          <Option value={-1}>Carregando...</Option>
        )}
      </Select>
    </Form.Item>
  );
};
